import { format, money, parse } from '@deli/money';

/** Date-times are shown in Kyiv time (spec §9), whatever the browser's time zone. */
const dateTime = new Intl.DateTimeFormat('uk-UA', {
  timeZone: 'Europe/Kyiv',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDateTime(iso: string | null | undefined): string {
  return iso ? dateTime.format(new Date(iso)) : '—';
}

/** Kopecks as "1 299,00 ₴" (the shared money formatter, non-breaking spaces). */
export const formatMoney = (kopecks: number | null | undefined): string =>
  kopecks === null || kopecks === undefined ? '—' : format(money(kopecks));

/** Hryvnias typed by a person ("1299", "1 299,50") → kopecks; null when it isn't an amount. */
export function parseMoneyInput(text: string): number | null {
  try {
    return parse(text).kopecks;
  } catch {
    return null;
  }
}

/** Kopecks as an editable hryvnia string ("1299,50"). */
export const toMoneyInput = (kopecks: number | null): string =>
  kopecks === null ? '' : `${Math.floor(kopecks / 100)},${String(kopecks % 100).padStart(2, '0')}`;
